import React, { Fragment } from 'react';
import {
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Toggle,
  Preloader,
  Badge,
  Stepper,
  Popover,
} from 'framework7-react';

import {
  PrimaryLogo,
  MerchantSvg,
  BikeSvg,
  WalletSvg,
} from '../components/crumbs';

import moment from 'moment';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getDistance } from 'geolib';
import { withStorage, firestoreConnect } from '../HOCs';
import { Collections, Doc, DocArray } from '../utils/_classes';

class Merchant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabName: 'Products',
    };
  }

  render() {
    return (
      <Page
        pageContent={false}
        style={{
          paddingBottom: '44px',
        }}>
        <Navbar sliding={false} backLink="Back">
          <NavTitle sliding> {this.state.tabName}</NavTitle>
        </Navbar>

        <Tabs animated style={{ overflowY: 'scroll' }} routable>
          <Tab className="page-content" id="merchant-products"></Tab>

          <Tab className="page-content" id="merchant-wallet"></Tab>

          <Tab className="page-content" id="merchant-sales"></Tab>
        </Tabs>

        {/* Tabbar for switching views-tabs to use lables add "label" to Toolbar and add text properties to Links*/}
        <Toolbar tabbar bottom id="merchant-tab" label>
          <Link
            tabLink
            href="./"
            iconF7="doc_richtext"
            text="Products"
            routeTabId="merchant-products"
            onClick={() =>
              this.setState({ ...this.state, tabName: 'Products' })
            }
          />
          <Link
            tabLink
            href="merchant-wallet/"
            iconF7="creditcard"
            text="Wallet"
            routeTabId="merchant-wallet"
            onClick={() => this.setState({ ...this.state, tabName: 'Wallet' })}
          />
          <Link
            tabLink
            href="merchant-sales/"
            iconF7="chart_bar"
            text="Sales"
            routeTabId="merchant-sales"
            onClick={() => this.setState({ ...this.state, tabName: 'Sales' })}>
            {this.props.orders &&
            this.props.orders.filter((o) => o.orderStatus === 'Order Pending')
              .length > 0 ? (
              <Badge
                color="red"
                style={{ position: 'absolute', top: 0, left: '50%' }}>
                {this.props.orders &&
                  this.props.orders.filter(
                    (o) => o.orderStatus === 'Order Pending'
                  ).length}
              </Badge>
            ) : null}
          </Link>
        </Toolbar>
      </Page>
    );
  }

  // events
  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : 'admin';
    const previousView = args[0] ? args[0] : 'account';
    const previousPage = args[2] ? args[2] : 'account';

    self.$f7.views['message-master'].router.navigate(
      {
        name: 'message-master',
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      }
    );
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { products, loading, transactions, orders },
    ordered,
    data,
  },
}) => ({
  auth,
  ordered,
  data,
  products: (products && products) || [],
  loadingDoc: loading,
  transactions: (transactions && transactions) || [],
  orders: (orders && orders) || [],
});

const enhance = compose(
  withStorage,
  firestoreConnect((props) => [
    new Collections('delivery'),
    new DocArray('products', props.auth.uid, 'merchantId'),
    new Doc(
      'wallets',
      (props.merchants &&
        props.merchants !== null &&
        props.merchants[props.auth.uid] &&
        props.merchants[props.auth.uid].walletId &&
        props.merchants[props.auth.uid].walletId) ||
        null
    ),
    new DocArray(
      'transactions',
      (props.merchants &&
        props.merchants[props.auth.uid] &&
        props.merchants[props.auth.uid].walletId &&
        props.merchants[props.auth.uid].walletId) ||
        null,
      'walletId'
    ),
    new DocArray(
      'orders',
      props.merchants && props.merchants[props.auth.uid]
        ? props.auth.uid
        : null,
      'merchantId'
    ),
  ]),
  connect(mapStateToProps)
);

export default enhance(Merchant);
